import React from "react";
import { useListing } from "@/providers";

export const AccomodationDetails = () => {

    const { listingDetails } = useListing();

    const {
        bedrooms,
    } = listingDetails;

    return (
        <div className="block-body !px-0 flex flex-col">
            <div className="mb-4 block-left">
                <h3 className="pb-4 text-lg font-bold text-start">Accommodations</h3>
            </div>
            {/* block-left */}
            <div className="grid grid-cols-1 gap-6 block-right md:grid-cols-3">
                {bedrooms?.map((room) => (
                    <div
                        key={room.id}
                        className="p-4 border rounded-lg shadow-lg block-col"
                    >
                        <div className="mb-2 block-icon">
                            {/* Add an optional icon here */}
                        </div>
                        <dl>
                            <dt className="mb-2 text-lg font-bold">{room.name}</dt>
                            <dd className="text-gray-700">
                                {room.no_of_bed} {room.bed_type}
                            </dd>
                            <dd className="text-gray-700">
                                {room.no_of_guest} Guest{room.no_of_guest > 1 ? "s" : ""}
                            </dd>
                        </dl>
                    </div>
                ))}
            </div>
            {/* block-right */}
        </div>
    );
};
